import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Mock Supabase client for development/demo purposes
const createMockSupabase = () => ({
  auth: {
    getSession: async () => {
      // Check localStorage for demo session
      const mockSession = localStorage.getItem('mock_session');
      if (mockSession) {
        try {
          const sessionData = JSON.parse(mockSession);
          return { data: { session: sessionData }, error: null };
        } catch {
          return { data: { session: null }, error: null };
        }
      }
      return { data: { session: null }, error: null };
    },
    signInWithPassword: async ({ email, password }) => {
      if (!email || !password) {
        return { data: null, error: { message: 'Email and password required' } };
      }
      // Mock login - store in localStorage
      const user = {
        id: 'mock-' + Math.random().toString(36).substr(2, 9),
        email,
        user_metadata: { role: 'client' },
      };
      const sessionData = {
        user,
        access_token: 'mock-token',
      };
      localStorage.setItem('mock_session', JSON.stringify(sessionData));
      return { data: { user, session: sessionData }, error: null };
    },
    signUp: async ({ email, password, options }) => {
      if (!email || !password) {
        return { data: null, error: { message: 'Email and password required' } };
      }
      // Mock signup - store in localStorage
      const user = {
        id: 'mock-' + Math.random().toString(36).substr(2, 9),
        email,
        user_metadata: options?.data || { role: 'client' },
      };
      const sessionData = {
        user,
        access_token: 'mock-token',
      };
      localStorage.setItem('mock_session', JSON.stringify(sessionData));
      return { data: { user, session: sessionData }, error: null };
    },
    signOut: async () => {
      localStorage.removeItem('mock_session');
      return { error: null };
    },
    onAuthStateChange: (callback) => {
      // Simple mock subscription
      const mockUnsubscribe = () => {};
      return { data: { subscription: { unsubscribe: mockUnsubscribe } } };
    },
  },
});

// Use real Supabase if credentials are available, fallback to mock
export const supabase = (supabaseUrl && supabaseAnonKey)
  ? createClient(supabaseUrl, supabaseAnonKey)
  : createMockSupabase();


